export default __webpack_public_path__ + "static/media/rocket_anim_58.61e59b0d.png";